<template>
  <section class="section">
    <header class="mod-title-lv1">
      <div class="inner">
        <h2>面接選考フロー・概要</h2>
        <p class="lead">
          ××職の選考フロー・面接概要情報です。
        </p>
      </div>
    </header>
    <section class="mod-job-content">
      <div class="mod-job-qa">
        <section class="item">
          <h4 class="mod-title-lv2 title green">
            書類選考の有無
          </h4>
          <div class="body">
            <p data-test="pager-screening">
              {{ interviewCountermeasure.includingPaperScreening | parseLabel }}
            </p>
          </div>
        </section>
        <section class="item">
          <h4 class="mod-title-lv2 title light-green">
            性格適性・能力試験の<br>有無
          </h4>
          <div class="body">
            <p data-test="spi-test">
              {{ interviewCountermeasure.spiTest | parseLabel }}
            </p>
            <p
              v-if="interviewCountermeasure.spiTestNote"
              class="mt15"
              data-test="spi-test-note"
            >
              {{ interviewCountermeasure.spiTestNote }}
            </p>
          </div>
        </section>
        <section class="item">
          <h4 class="mod-title-lv2 title sky-blue">
            デジタル応募書類の<br>可否
          </h4>
          <div class="body">
            <p data-test="digital-resume">
              {{ interviewCountermeasure.enabledDigitalResume | parseLabel }}
            </p>
          </div>
        </section>
        <section class="item">
          <h4 class="mod-title-lv2 title light-blue">
            内定までの選考期間
          </h4>
          <div class="body">
            <p data-test="selection-term">
              {{ interviewCountermeasure.selectionTerm | parseLabel }}
            </p>
          </div>
        </section>
        <section class="item">
          <h4 class="mod-title-lv2 title blue">
            面接回数
          </h4>
          <div class="body">
            <p data-test="interview-count">
              {{ interviewCountermeasure.interviewSteps | parseLabel }}
            </p>
          </div>
        </section>
        <section class="item">
          <h4 class="mod-title-lv2 title purple">
            面接可能な<br>日程・時間帯
          </h4>
          <div class="body">
            <p data-test="interview-time-zone">
              【時間帯】{{ interviewCountermeasure.interviewTimeZone | parseLabel }}
            </p>
            <p data-test="interview-day-of-week">
              【日程】{{ interviewCountermeasure.interviewDayOfTheWeek | parseLabel }}
            </p>
          </div>
        </section>
        <section class="item">
          <h4 class="mod-title-lv2 title pink">
            面接時の服装
          </h4>
          <div class="body">
            <p data-test="clothes">
              {{ interviewCountermeasure.clothes | parseLabel }}
            </p>
            <p>
              <span class="mod-icon required">ポイント</span>
              面接時の服装注意点・アドバイスはコチラ
            </p>
            <p class="ml60">
              <a
                target="_blank"
                data-test="caution-suit"
                :href="userEndPoint+'/s/manual/interview/window/suit.html'"
              >スーツの注意点</a>
              /
              <a
                target="_blank"
                data-test="caution-casual"
                :href="userEndPoint+'/s/manual/interview/window/biz_casual.html'"
              >ビジネスカジュアルの注意点</a>
              /
              <a
                target="_blank"
                data-test="caution-casual-free"
                :href="userEndPoint+'/s/manual/interview/window/casual.html'"
              >服装自由の注意点</a>
            </p>
          </div>
        </section>
        <section class="item">
          <h4 class="mod-title-lv2 title orange">
            面接の所要時間
          </h4>
          <div class="body">
            <p data-test="interview-time">
              {{ interviewCountermeasure.timeRequired | parseLabel }}
            </p>
          </div>
        </section>
      </div>
    </section>
  </section>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/base" as *;
</style>

<script>
export default {
  filters: {
    parseLabel (val) {
      return val ? val.name : ''
    }
  },
  props: {
    interviewCountermeasure: {
      type: Object,
      required: true
    },
    userEndPoint: {
      type: String,
      required: true
    }
  }
}
</script>
